export default {
  NEW: 'New',
  IN_PROGRESS: 'In progress',
  COMPLETED: 'Completed'
} as { [key: string]: string }
